import React from "react";
import { connect } from "react-redux";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MaterialDataTable from "material-table/Table.js";
import {
  crudActions,
  confirmActions,
  modalActions,
  loaderActions,
} from "../../../_actions";
import { fileService } from "../../../_services/file.service";
import { TableAction } from "../../../material-table/TableAction";
import { PermissionHelper } from "_helpers";

const title = "Service";
class ConsultantList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.deleteCrud = this.deleteCrud.bind(this);
    this.addCrud = this.addCrud.bind(this);
    this.editCrud = this.editCrud.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
  }

  componentDidUpdate() {
    if (this.props.confirm.confirm) {
      if (this.props.confirm.data.length) {
        const ids = this.props.confirm.data.map((value) => value.id);
        this.props.deleteAllCrud("form", "services/delete_all", {
          ids: JSON.stringify(ids),
        });
      } else {
        if (this.props.confirm.data.id) {
          this.deleteData(this.props.confirm.data.id);
        }
      }
      this.props.clearConfirm();
    }
  }
  toggleModal(log) {
    this.props.openModal({
      open: true,
      component: log,
    });
  }

  deleteData = (id) => {
    this.props.deleteCrud("form", "services", id);
  };

  deleteCrud(data) {
    this.props.showConfirm(
      "Confirm",
      `Are you sure want to delete ${data.first_name} ?`,
      data
    );
  }

  deleteAll(data) {
    this.props.showConfirm(
      "Confirm",
      `Are you sure want to delete ${data.length} row ?`,
      data
    );
  }

  editCrud(data) {
    this.props.history.push(`/admin/service-form/${data.id}`);
  }

  addCrud() {
    this.props.history.push(`/admin/service-form/new`);
  }
  export = () => {
    fileService._download("reports/servicereport");
  };
  render() {
    const columns = [
      {
        title: "Name",
        field: "name",
      },
      {
        title: "Description",
        field: "description",
      },
      {
        title: "Component",
        field: "component",
      },
      {
        title: "Outcome",
        field: "outcome",
      },
      {
        title: "Price",
        field: "price",
      },
      {
        title: "SEO Slug URL",
        field: "seo_url_slug",
      },
      {
        title: "Meta Description",
        field: "meta_description",
      },
      {
        title: "Meta Title",
        field: "meta_title",
      },
      {
        title: "Created Date",
        field: "created_at",
        defaultSort: "desc",
      },

      TableAction(
        PermissionHelper.checkPermission("delete_consultant")
          ? this.deleteCrud
          : null,
        PermissionHelper.checkPermission("edit_consultant")
          ? this.editCrud
          : null,
        false,
        false,
        false
      ),
    ];

    return (
      <GridContainer>
        <GridItem xs={12}>
          <MaterialDataTable
            title={title}
            columns={columns}
            addData={
              PermissionHelper.checkPermission("add_consultant")
                ? this.addCrud
                : false
            }
            deleteAll={
              PermissionHelper.checkPermission("delete_consultant")
                ? this.deleteAll
                : false
            }
            url="services"
            selection={true}
            grouping={false}
            defaultExpanded={true}
            refresh={true}
            serverSide={true}
            search={true}
            sorting={true}
            filtering={true}
            export={
              PermissionHelper.checkPermission("export_services")
                ? this.export
                : false
            }
          />
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { authentication, confirm } = state;
  const { user } = authentication;
  return { user, confirm };
};

const actionCreators = {
  getRole: crudActions._get,
  deleteCrud: crudActions._delete,
  deleteAllCrud: crudActions._deleteAll,
  showConfirm: confirmActions.show,
  clearConfirm: confirmActions.clear,
  openModal: modalActions.open,
  showLoader: loaderActions.show,
  hideLoader: loaderActions.hide,
  activateConsultant: crudActions._create,
  deactivateConsultant: crudActions._create,
};

export default connect(
  mapStateToProps,
  actionCreators
)(ConsultantList);
